export const ENABLE_PAGE_TRANSITION = 'ENABLE_PAGE_TRANSITION'
export const DISABLE_PAGE_TRANSITION = 'DISABLE_PAGE_TRANSITION'
export const SET_PAGE_SWITCHING = 'SET_PAGE_SWITCHING'
export const SET_PAGE_TRANSITION_NAME = 'SET_PAGE_TRANSITION_NAME'
export const SAVE_SCROLLY = 'SAVE_SCROLLY'
